import { gql } from '@apollo/client';

const GET_COMMON_FORMS = gql`
  query ($formTemplatesQueryInput: FormTemplatesQueryInput) {
    getFormTemplates(formTemplatesQueryInput: $formTemplatesQueryInput) {
      _id
      name
      icon
      isCommonForm
      pages {
        _id
        index
        name
        sections {
          _id
          index
          name
          description
          rows {
            _id
            index
            fields {
              _id
              name
              type
              label
              required
              validations
              variant
              placeholder
              tooltip
              canSelectFutureDate
              clearAfterEdit
              saveDateOfSignature
              useRichTextLabelInput
              options {
                value
                label
                metadata {
                  isBold
                }
              }
              image
              rows {
                value
                label
              }
              columns {
                type
                value
                label
                placeholder
                options {
                  value
                  label
                  metadata {
                    isBold
                  }
                }
                variant
                required
                validations
                hideInTable
                visibleWhen
                otherSpecificationField
              }
            }
          }
        }
      }
    }
  }
`;

export default GET_COMMON_FORMS;
